import { themeEstra } from 'src/styles/themeEstra'

export const getThemeColor = (colorString?: string): string => {
  switch (colorString) {
    case 'verde':
      return themeEstra.color.primari.verde

    case 'verdeChiaro':
      return themeEstra.color.bg.verde1

    case 'verdeScuro':
      return themeEstra.color.secondari.verdeScuro

    case 'ciano':
      return themeEstra.color.primari.ciano

    case 'cianoChiaro':
      return themeEstra.color.bg.ciano1

    case 'cianoScuro':
      return themeEstra.color.secondari.cianoScuro

    case 'viola':
      return themeEstra.color.primari.viola

    case 'fucsia':
      return themeEstra.color.primari.fucsia

    case 'arancione':
      return themeEstra.color.primari.arancione

    case 'arancioneChiarissimo':
      return themeEstra.color.bg.arancione2

    case 'giallo':
      return themeEstra.color.primari.giallo

    case 'gialloChiaro':
      return themeEstra.color.bg.giallo1

    case 'gialloChiarissimo':
      return themeEstra.color.bg.giallo2

    case 'grigio':
      return themeEstra.color.primari.grigioEstra

    case 'nero':
      return themeEstra.color.primari.neroEstra

    case 'bianco':
      return '#fff'

    case 'violaCiano':
      return themeEstra.gradientiBi.violaCiano

    default:
      return ''
  }
}
